import { render, staticRenderFns } from "./RectivateDrawer.vue?vue&type=template&id=56143ac4&scoped=true&"
import script from "./RectivateDrawer.vue?vue&type=script&lang=js&"
export * from "./RectivateDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56143ac4",
  null
  
)

export default component.exports